/* eslint-disable jsdoc/check-param-names */
import { Dispatch, SetStateAction } from "react";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";

type Props = {
  id: string;
  label: string;
  value: string;
  onChange: (val: any) => void;
  options: string[] | readonly string[];
  required?: boolean;
  disabled?: boolean;
};

/**
 * カスタムテキストフィールド
 * @param id フィールドID
 * @param label ラベル
 * @param value 値
 * @param onChange 値が選択される
 * @param required 必須かどうか
 * @param disabled 非活性
 * @param isContainBlank 選択肢に空白を含むかどうか
 * @returns JSX.Element
 */
export default function LabeledButtons({
  id,
  label,
  value,
  onChange,
  options,
  required,
  disabled,
}: Props) {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      position="relative"
      height={50}
      width={0}
      margin="0 auto"
    >
      <Box textAlign="right" marginRight={1} position="absolute" right={10} width="max-content">
        {`${label}${required ? <Typography sx={{color: 'red'}}>{' *'}</Typography> : ''}`}：
      </Box>
      <Box position="absolute" width="max-content" minWidth={100} left={5}>
        {options.map(o => (
          value === o ? (
            <Button key={id + o} variant="selected-gray-outlined" sx={{ml: 1}} value={o} onClick={(e) => onChange(e.currentTarget.value)} disabled={disabled}>
              {o}
            </Button>
          ) : (
            <Button key={id + o} variant="gray-outlined" sx={{ml: 1}} value={o} onClick={(e) => onChange(e.currentTarget.value)} disabled={disabled}>
              {o}
            </Button>
          )
        ))}
        {/* <FormControl sx={{ minWidth: 160, width: "100%", maxWidth: 207 }} required={required}>
          <InputLabel
            id={`${id}-label`}
            sx={{
              top: "-6px",
              "&.MuiInputLabel-shrink": {
                transform: "translate(14px, -4px) scale(0.75)",
              },
              "& .MuiFormLabel-asterisk": {
                color: "var(--red-800)",
              },
            }}
          >
            {label}
          </InputLabel>
          <Select
            labelId={`${id}-label`}
            label={label}
            id={id}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            sx={{ height: "40px" }}
            disabled={disabled}
          >
            {isContainBlank && (
              // eslint-disable-next-line no-irregular-whitespace, react/self-closing-comp
              <MenuItem key="" value="">
                &emsp;
              </MenuItem>
            )}
            {options.map((s) => (
              <MenuItem key={s} value={s}>
                {s}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
      </Box>
    </Stack>
  );
}
